/*
 * If you add a locale here, you must also:
 * - add it to the lyaml file
 * - check the locales are supported by Google Recaptcha (We change the recaptcha locale
 *   when lang select changes): https://developers.google.com/recaptcha/docs/language?hl=en
 */
export const LOCALES = ['af', 'ar-eg', 'bg', 'bn', 'ca-es', 'cs', 'da', 'de', 'el', 'en', 'en-gb', 'es', 'es-mx', 'et', 'fi', 'fr', 'fr-ca', 'he-il', 'hi', 'hr', 'hu', 'id', 'it', 'ja', 'ko', 'lt', 'ms', 'nl', 'no', 'pl', 'pt-br', 'pt-pt', 'ro', 'ru', 'sk', 'sl', 'sv', 'th', 'tl', 'tr', 'uk', 'vi', 'zh-cn', 'zh-hk', 'zh-tw'];